import React from "react";
import { Row, Col } from "react-bootstrap";
import { DateConvert } from "utilities";

const InfoSection = ({ data }) => {
  const InfoItem = ({ title, text }) => (
    <tr>
      <td className="align-top" style={{ fontSize: 14 }}>
        {title}
      </td>
      <td className="pl-4 pr-2 align-top" style={{ fontSize: 14 }}>
        :
      </td>
      <td className="align-top" style={{ fontSize: 14 }}>
        {text}
      </td>
    </tr>
  );
  return (
    <>
      <Row>
        <Col md={6}>
          <InfoItem
            title="Tgl. Voucher"
            text={data.tgl_voucher ? DateConvert(new Date(data.tgl_voucher)).detail : "-"}
          />
          <InfoItem title="No. Voucher" text={data.no_voucher ?? "-"} />
        </Col>
        <Col mmd={6}>
          <InfoItem title="Vendor" text={data.nama_vendor ?? "-"} />
          <InfoItem title="Proyek" text={data.nama_proyek ?? "-"} />
        </Col>
      </Row>
    </>
  );
};

export default InfoSection;
